<section class="commesse-page">
  <div class="container">
    <!-- Header -->
    <section class="page-header">
      <div class="title-section">
        <h1 class="title-text">
          <span class="material-symbols-outlined">work</span>
          <span>Commesse</span>
        </h1>
      </div>
      <div class="header-actions">
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Nuova Commessa"
          class="add-button p-button-rounded"
          aria-label="Aggiungi nuova commessa"
          (click)="openCreateCommessaDialog()"
          *ngIf="canModify()"
        ></button>
        <div class="stats-block">
          <div class="stat-card primary">
            <span class="stat-label">Totale Commesse</span>
            <span class="stat-value">{{ commesse.length }}</span>
          </div>
          <div class="stat-card secondary" *ngIf="searchText">
            <span class="stat-label">Risultati</span>
            <span class="stat-value stat-value-filtered">{{ filteredCommesse.length }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Sezione ricerca -->
    <section class="search-section">
      <div class="search-row-compact">
        <div class="search-field">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
              placeholder="Cerca per codice, descrizione o cliente..."
            />
          </span>
        </div>
        <button
          *ngIf="searchText"
          type="button"
          class="clear-search-btn"
          (click)="clearSearch()"
          pTooltip="Cancella ricerca"
          tooltipPosition="top"
        >
          <i class="pi pi-times"></i>
          <span>Cancella</span>
        </button>
      </div>
    </section>

    <!-- Sezione tabella -->
    <section class="table-section" *ngIf="commesse.length > 0; else noCommesse">
      <div class="table-card">
        <div class="table-content">
          <p-table
            [value]="filteredCommesse"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            [resizableColumns]="true"
            [responsiveLayout]="'scroll'"
            [loading]="loading"
            class="commesse-table"
            [sortField]="'codice'"
            [sortOrder]="1"
          >
            <ng-template pTemplate="header">
              <tr>

                <th pResizableColumn pSortableColumn="clienteRagioneSociale" style="width: 300px; max-width: 400px; min-width: 250px">
                  Cliente
                </th>
                <th pResizableColumn pSortableColumn="codice" style="min-width: 150px">
                  Codice
                </th>
                <th pResizableColumn pSortableColumn="descrizione" style="width: 350px; max-width: 400px; min-width: 250px">
                  Descrizione
                </th>

                <th pResizableColumn pSortableColumn="chiusa" style="width: 120px; text-align: center;">
                  Stato
                </th>
                <th pResizableColumn pSortableColumn="numeroReferenze" style="min-width: 140px; text-align: center;">
                  Numero Referenze
                </th>
                <th style="width: 120px; text-align: center;" *ngIf="canModify()">
                  Azioni
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-commessa>
              <tr class="commessa-row" [class.editing]="isEditing(commessa.id)">
                <td>
                  <span
                    class="cliente-badge"
                    [pTooltip]="commessa.clienteRagioneSociale"
                    tooltipPosition="top"
                    [showDelay]="300"
                  >
                   <!--  <i class="pi pi-building"></i> -->
                    <span class="cliente-text">{{ commessa.clienteRagioneSociale }}</span>
                  </span>
                </td>
                <td>
                  <!-- Modalità visualizzazione -->
                  <span class="codice-commessa" *ngIf="!isEditing(commessa.id)">
                    {{ commessa.codice }}
                  </span>

                  <!-- Modalità editing -->
                  <div class="edit-container" *ngIf="isEditing(commessa.id)">
                    <input
                      type="text"
                      pInputText
                      [(ngModel)]="editingCodice"
                      class="edit-input"
                      [class.error]="isEditCodiceDuplicate()"
                      [disabled]="savingEdit"
                      (keydown.enter)="!isEditCodiceDuplicate() && editingDescrizione.trim() && saveEdit()"
                      (keydown.escape)="cancelEdit()"
                      placeholder="Codice"
                    />
                    <small class="p-error" *ngIf="isEditCodiceDuplicate()">
                      Codice già esistente
                    </small>
                  </div>
                </td>

                <td>
                  <!-- Modalità visualizzazione -->
                  <div class="descrizione-container" *ngIf="!isEditing(commessa.id)">
                    <div
                      class="descrizione-box"
                      [pTooltip]="commessa.descrizione"
                      tooltipPosition="top"
                      [showDelay]="300"
                    >
                      <span class="descrizione-text">{{ commessa.descrizione }}</span>
                    </div>
                  </div>

                  <!-- Modalità editing -->
                  <div class="edit-container" *ngIf="isEditing(commessa.id)">
                    <textarea
                      pInputTextarea
                      [(ngModel)]="editingDescrizione"
                      class="edit-input edit-textarea"
                      [disabled]="savingEdit"
                      placeholder="Descrizione"
                      [rows]="2"
                      [autoResize]="true"
                    ></textarea>
                  </div>
                </td>

                <td style="text-align: center;">
                  <span
                    class="stato-badge"
                    [ngClass]="{
                      'stato-aperta': !commessa.chiusa,
                      'stato-chiusa': commessa.chiusa
                    }"
                    [pTooltip]="commessa.chiusa ? 'Commessa chiusa - Click per aprire' : 'Commessa aperta - Click per chiudere'"
                    tooltipPosition="top"
                    (click)="canModify() && toggleStatoCommessa(commessa)"
                    [style.cursor]="canModify() ? 'pointer' : 'default'"
                  >
                    <span class="material-symbols-outlined">
                      {{ commessa.chiusa ? 'lock' : 'lock_open' }}
                    </span>
                  </span>
                </td>
                <td style="text-align: center;">
                  <span 
                    class="referenze-count" 
                    [class.clickable]="commessa.numeroReferenze > 0"
                    (click)="navigateToHomeWithCommessa(commessa)"
                    [pTooltip]="commessa.numeroReferenze > 0 ? 'Clicca per vedere le referenze di questa commessa' : ''"
                    tooltipPosition="top"
                  >
                    {{ commessa.numeroReferenze || 0 }}
                  </span>
                </td>
                <td class="actions-cell" *ngIf="canModify()">
                  <!-- Azioni normali -->
                  <div class="action-buttons" *ngIf="!isEditing(commessa.id)">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-text p-button-info action-btn edit-btn"
                      pTooltip="Modifica commessa"
                      tooltipPosition="top"
                      (click)="startEdit(commessa)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-text p-button-danger action-btn delete-btn"
                      [pTooltip]="commessa.numeroReferenze > 0 ? 'Non è possibile eliminare una commessa con referenze associate (' + commessa.numeroReferenze + ' referenze)' : 'Elimina commessa'"
                      tooltipPosition="top"
                      [disabled]="commessa.numeroReferenze > 0"
                      (click)="confirmDelete(commessa)"
                    ></button>
                  </div>

                  <!-- Azioni editing -->
                  <div class="edit-actions" *ngIf="isEditing(commessa.id)">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-check"
                      class="p-button-rounded p-button-success p-button-sm confirm-btn"
                      pTooltip="Salva modifiche"
                      tooltipPosition="top"
                      [disabled]="!editingCodice.trim() || !editingDescrizione.trim() || isEditCodiceDuplicate() || savingEdit"
                      [loading]="savingEdit"
                      (click)="saveEdit()"
                    ></button>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-rounded p-button-secondary p-button-sm cancel-btn"
                      pTooltip="Annulla modifiche"
                      tooltipPosition="top"
                      [disabled]="savingEdit"
                      (click)="cancelEdit()"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="canModify() ? 5 : 4" class="text-center">
                  <div class="empty-state">
                    <span class="material-symbols-outlined empty-icon">search_off</span>
                    <p class="empty-message">Nessuna commessa trovata</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </section>

    <!-- Nessuna commessa -->
    <ng-template #noCommesse>
      <section class="empty-section">
        <div class="empty-state-large">
          <span class="material-symbols-outlined">work_off</span>
          <h3>Nessuna Commessa</h3>
          <p class="text-muted">Non ci sono commesse disponibili nel sistema.</p>
          <button
            pButton
            type="button"
            icon="pi pi-plus"
            label="Crea la prima commessa"
            class="p-button-lg"
            (click)="openCreateCommessaDialog()"
            *ngIf="canModify()"
          ></button>
        </div>
      </section>
    </ng-template>
  </div>
</section>

<!-- Dialog Creazione Commessa -->
<app-create-commessa-dialog
  [(visible)]="showCreateCommessaDialog"
  [commesse]="commesse"
  (commessaCreated)="onCommessaCreated()"
></app-create-commessa-dialog>

<!-- Dialog Conferma Eliminazione -->
<p-confirmDialog></p-confirmDialog>
